const subSerializer = ((node, children) => {
  return `<sub alias="${node.alias}">${children}</sub>`;
});

export { subSerializer };
//# sourceMappingURL=serializer.js.map
